/* eslint-env jquery */
import $ from 'jquery';
import initSlick from 'slick-carousel/slick/slick.js';
initSlick(globalThis, $);

if (jQuery('.testimonials-cards').length) {
  testimonialCards();
}

function testimonialCards() {
  jQuery('.testimonials-cards .slide').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    responsive: [
      {
        breakpoint: 991.98,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 767.98,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
